import RouterView from '@/components/RouterView'

const menuList = [{
    path: '/flightDeck',
    name: 'flightDeck',
    component: RouterView,
    redirect: '/flightDeck',
    meta: {
      title: '驾驶舱',
      isMenu: true
    },
    children: [{
        path: '/flightDeck',
        // name: 'flightDeck',
        component: () => import('../views/flightDeck/index.vue'),
      },
      {
        path: '/flightDeck/businessManager',
        name: 'businessManager',
        component: () =>
          import('../views/flightDeck/pageList/businessManager.vue'),
        meta: {
          title: '',
          isMenu: false
        }
      },
      {
        path: '/flightDeck/counselorPage',
        name: 'counselorPage',
        component: () =>
          import('../views/flightDeck/pageList/counselorPage.vue'),
        meta: {
          title: '',
          isMenu: false
        }
      }
    ]
  },



  {
    path: '/dataManagement',
    name: 'dataManagement',
    component: RouterView,
    redirect: '/dataManagement/List',
    meta: {
      title: '企业数据',
      isMenu: true
    },
    children: [{
      path: '/dataManagement/List',
      component: RouterView,
      redirect: '/dataManagement/enterpriseList',
      children: [{
          path: '/dataManagement/enterpriseList',
          name: 'enterpriseList',
          component: () => import('../views/dataManagement/enterpriseList/index.vue')
        },
        {
          path: '/dataManagement/businessDetails',
          name: 'businessDetails',
          component: () =>
            import('../views/dataManagement/enterpriseList/components/businessDetails.vue'),
          meta: {
            title: '企业信息',
            isMenu: true
          }
        },
        {
          path: '/dataManagement/addEnterprise',
          name: 'enterpriseInfo',
          component: () =>
            import('../views/dataManagement/enterpriseList/components/enterpriseInfo.vue'),
          meta: {
            title: '添加企业',
            isMenu: true
          }
        },
        {
          path: '/dataManagement/updateEnterprise',
          // name: 'enterpriseInfo',
          component: () =>
            import('../views/dataManagement/enterpriseList/components/enterpriseInfo.vue'),
          meta: {
            title: '编辑企业',
            isMenu: true
          }
        }
      ]
    }]
  },
  {
    path: '/dataManagement/positionList',
    name: 'PositionList',
    component: RouterView,
    meta: {
      title: '职位数据',
      isMenu: true
    },
    children: [{
        path: '/dataManagement/positionList',
        // name: 'PositionList',
        component: () => import('../views/dataManagement/positionList/index.vue')
      },
      {
        path: '/dataManagement/positionMessage',
        name: 'PositionMessage',
        component: () => import('../views/dataManagement/positionList/info'),
        meta: {
          title: '职位信息',
          isMenu: true
        }
      },
      {
        path: '/dataManagement/positionMessageView',
        name: 'PositionMessageView',
        component: () => import('../views/dataManagement/positionList/info/view.vue'),
        meta: {
          title: '浏览职位信息',
          isMenu: true
        }
      }
    ]
  },
  {
    path: '/dataManagement/talentList',
    name: 'TalentList',
    component: RouterView,
    meta: {
      title: '人才数据',
      isMenu: true
    },
    children: [{
        path: '/dataManagement/talentList',
        // name: 'TalentList',
        component: () => import('../views/dataManagement/talentList/index.vue')
      },
      {
        path: '/dataManagement/TalentMessage',
        name: 'TalentMessage',
        component: () => import('../views/dataManagement/talentList/info'),
        meta: {
          title: '人才信息',
          isMenu: true
        }
      },
      {
        path: '/dataManagement/TalentMessageView',
        name: 'TalentMessageView',
        component: () => import('../views/dataManagement/talentList/info/view.vue'),
        meta: {
          title: '浏览人才信息',
          isMenu: true
        }
      }
    ]
  },

  {
    path: '/dataManagement/verbalTrickData',
    name: 'verbalTrickData',
    component: RouterView,
    meta: {
      title: '话术数据',
      isMenu: true
    },
    children: [{
      path: '/dataManagement/verbalTrickData',
      // name: 'verbalTrickData',
      component: () => import('../views/dataManagement/verbalTrickData/index.vue')
    }, ]
  },

  {
    path: '/businessManagement/projectCenter',
    name: 'ProjectCenter',
    component: RouterView,
    meta: {
      title: '自营项目',
      isMenu: true,
    },
    children: [{
        path: '/businessManagement/projectCenter',
        component: () => import('../views/businessManagement/projectCenter/index.vue'),
        meta: {
          keepAlive: true // 不需要缓存

        }
      },
      {
        path: '/businessManagement/workbench',
        name: 'Workbench',
        meta: {
          title: '工作台',
          isMenu: true
        },
        component: RouterView,
        children: [{
            path: '/businessManagement/workbench',
            // name: 'Workbench',
            component: () => import('../views/businessManagement/projectCenter/workbench/index.vue'),
          },
          {
            path: '/businessManagement/workbench/projectAlternatives',
            name: 'projectAlternatives',
            component: () => import('../views/businessManagement/projectCenter/workbench/components/projectAlternatives.vue'),
            meta: {
              title: '寻访方案',
              isMenu: true
            }
          },
        ]
      },
      {
        path: '/businessManagement/projectCenter/addProject',
        name: 'addProject',
        component: () =>
          import('../views/businessManagement/projectCenter/addProject/index.vue'),
        meta: {
          title: '编辑项目',
          isMenu: true
        }
      },
      {
        path: '/businessManagement/projectCenter/projectInfo/operationManagement',
        name: 'OperationManagement',
        meta: {
          title: '沟通列表',
          isMenu: true
        },
        component: RouterView,
        children: [{
            path: '/businessManagement/projectCenter/projectInfo/operationManagement',
            // name: 'OperationManagement',
            component: () =>
              import('../views/businessManagement/projectCenter/projectInfo/operationManagement.vue'),
          },
          {
            path: '/businessManagement/workbench/editReport',
            // name: 'EditReport',
            component: () => import('../views/businessManagement/projectCenter/workbench/components/editReport/index.vue'),
            meta: {
              title: '编辑报告',
              isMenu: true
            },
          }

        ]
      },
      {
        path: '/businessManagement/projectCenter/addEditprojectInfo',
        name: 'AddEditprojectInfo',
        component: () =>
          import('../views/businessManagement/projectCenter/projectInfo/projectInfo.vue'),
        meta: {
          title: '项目信息',
          isMenu: true
        }
      },
      {
        path: '/businessManagement/projectCenter/candidate',
        name: 'Candidate',
        component: RouterView,
        meta: {
          title: '候选人',
          isMenu: true
        },
        children: [{
            path: '/businessManagement/projectCenter/candidate',
            component: () => import('../views/businessManagement/projectCenter/candidate')
          },
          {
            path: 'editReport',
            name: 'EditReport',
            component: RouterView,
            meta: {
              title: '编辑报告',
              isMenu: true
            },
            children: [{
              path: '/businessManagement/projectCenter/candidate/editReport',
              component: () =>
                import(
                  '../views/businessManagement/projectCenter/candidate/communicationList/editReport'
                )
            }]
          },
          {
            path: 'records',
            name: 'Records',
            component: RouterView,
            meta: {
              title: '候选人记录',
              isMenu: true
            },
            children: [{
              path: '/businessManagement/projectCenter/candidate/records',
              component: () =>
                import(
                  '../views/businessManagement/projectCenter/candidate/communicationList/records/index.vue'
                )
            }]
          }
        ]
      },
      {
        path: '/businessManagement/projectCenter/projectRecord',
        name: 'projectRecord',
        component: RouterView,
        meta: {
          title: '项目记录',
          isMenu: true
        },
        children: [{
          path: '/businessManagement/projectCenter/projectRecord',
          component: () =>
            import('../views/businessManagement/projectCenter/projectRecord/index.vue')
        }]
      },
      {
        path: '/businessManagement/projectCenter/viewProject',
        name: 'ViewProject',
        component: () =>
          import('../views/businessManagement/projectCenter/projectInfo/viewProject.vue'),
        meta: {
          title: '查看项目详情',
          isMenu: true
        }
      }
    ]
  },

  // 新增菁亿项目
  {
    path: '/businessManagement/JingyiProject',
    name: 'JingyiProject',
    component: RouterView,
    redirect: '/businessManagement/JingyiProject',
    meta: {
      title: '菁亿项目',
      isMenu: true
    },
    children: [{
        path: '/businessManagement/JingyiProject',
        component: () => import('../views//businessManagement/JingyiProject/index.vue'),
      },
      {
        path: '/businessManagement/recommendedList',
        name: 'recommendedList',
        component: () => import('../views/businessManagement/JingyiProject/recommendedList.vue'),
        meta: {
          title: '推荐列表',
          isMenu: true
        },
      },
      {
        path: '/businessManagement/editProject',
        name: 'editProject',
        component: () => import('../views/businessManagement/JingyiProject/components/editProject.vue'),
        meta: {
          title: '编辑项目',
          isMenu: true
        },
      },
      {
        path: '/businessManagement/recommendedReport',
        name: 'editProject',
        component: () => import('../views/businessManagement/JingyiProject/components/recommendedReport.vue'),
        meta: {
          title: '编辑报告',
          isMenu: true
        },
      },
      {
        path: '/businessManagement/archivesCenter',
        name: 'archivesCenterJy',
        component: () => import('../views/businessManagement/JingyiProject/components/archivesCenter.vue'),
        meta: {
          title: '文档中心',
          isMenu: true
        },
      },
    ]
  },



  {
    path: '/businessManagement/customerCenter',
    name: 'CustomerCenter',
    meta: {
      title: '客户中心',
      isMenu: true
    },
    component: RouterView,
    redirect: '/businessManagement/customerCenter',
    children: [{
        path: '/businessManagement/customerCenter',
        component: () => import('../views/businessManagement/customerCenter/index.vue')
      },
      {
        path: '/businessManagement/customerCenter/customInfo',
        name: 'CustomerCenterInfo',
        component: () => import('../views/businessManagement/customerCenter/info.vue'),
        meta: {
          title: '客户信息',
          isMenu: true
        }
      }
    ]
  },
  {
    path: '/businessManagement/caseList',
    name: 'caseList',
    component: RouterView,
    redirect: '/businessManagement/caseCenter',
    meta: {
      title: '案例中心',
      isMenu: true
    },
    children: [{
        path: '/businessManagement/caseCenter',
        name: 'CaseCenter',
        component: () => import('../views/businessManagement/caseCenter/index.vue')
      },
      {
        path: '/businessManagement/viewCaseInfo',
        name: 'viewCaseInfo',
        component: () => import('../views/businessManagement/caseCenter/info.vue'),
        meta: {
          title: '案例信息',
          isMenu: true
        }
      }
    ]
  },

  {
    path: '/businessCenter',
    name: 'businessCenter',
    component: RouterView,
    redirect: '/businessCenter/investmentEvent',
    // meta: {
    //   title: '业务中心',
    //   isMenu: true
    // },
    children: [{
        path: '/businessCenter/investmentEvent',
        name: 'investmentEvent',
        component: () => import('../views/businessCenter/investmentEvent/index.vue'),
        meta: {
          title: '投资事件',
          isMenu: true
        },
      },
      {
        path: '/businessCenter/editInfomation',
        name: 'editInfomation',
        component: () => import('../views/businessCenter/investmentEvent/components/EditInfomation.vue'),
        meta: {
          title: '编辑事件',
          isMenu: true
        }
      },
      {
        path: '/businessCenter/clueCenter',
        name: 'clueCenter',
        // component: () => import('../views/businessCenter/clueCenter/index.vue'),
        component: RouterView,
        meta: {
          title: '线索中心',
          isMenu: true
        },
        children: [{
            path: '/businessCenter/clueCenter',
            component: () => import('../views/businessCenter/clueCenter/index.vue'),
          },
          {
            path: '/businessCenter/clueCenter/clueParticulars',
            name: 'clueParticulars',
            // component: () => import('../views/businessCenter/clueParticulars/index.vue'),
            component: RouterView,
            meta: {
              title: '线索详情',
              isMenu: true
            },
            children: [{
                path: '/businessCenter/clueCenter/clueParticulars',
                component: () => import('../views/businessCenter/clueParticulars/index.vue'),
              },
              {
                path: '/businessCenter/clueCenter/clueParticulars/newAddKey',
                name: 'newAddKey',
                component: () => import('../views/businessCenter/clueParticulars/pages/newAddKey.vue'),
                meta: {
                  title: '新增关键人',
                  isMenu: true
                },
              }
            ]
          },
          {
            path: '/businessCenter/clueCenter/informationMessage',
            name: 'informationMessage',
            component: () => import('../views/businessCenter/clueParticulars/pages/informationMessage.vue'),
            meta: {
              title: '资讯详情',
              isMenu: true
            }
          }
        ]
      },
      {
        path: '/businessCenter/customerCenter',
        name: 'customerCenter',
        component: RouterView,
        meta: {
          title: '客户中心',
          isMenu: true
        },
        children: [{
            path: '/businessCenter/customerCenter',
            // name: 'customerCenter',
            component: () => import('../views/businessCenter/customerCenter/index.vue'),
          },
          {
            path: '/businessCenter/customerDetails',
            name: 'customerDetails',
            component: () => import('../views/businessCenter/customerCenter/pages/customerDetails.vue'),
            meta: {
              title: '客户详情',
              isMenu: true
            },
          },
        ]
      }
    ]
  },

  // 新增菁亿用户
  {
    path: '/jingyiUsers',
    name: 'jingyiUsers',
    component: RouterView,
    redirect: '/jingyiUsers',
    meta: {
      title: '菁亿用户',
      isMenu: true
    },
    children: [{
        path: '/jingyiUsers',
        component: () => import('../views/jingyiUsers/index.vue'),
      },
      {
        path: '/jingyiUsers/auditing',
        name: 'auditing',
        component: () => import('../views/jingyiUsers/components/auditing.vue'),
        meta: {
          isMenu: true
        },
      },
      {
        path: '/jingyiUsers/usersDetail',
        name: 'usersDetail',
        component: () => import('../views/jingyiUsers/components/usersDetail.vue'),
        meta: {
          isMenu: true
        },
      },
    ]
  },


  //系统管理
  {
    path: '/systemManagement',
    name: 'systemManagement',
    component: RouterView,
    redirect: '/systemManagement/menuManagementList',
    children: [{
        path: '/systemManagement/menuManagementList',
        name: 'menuManagement',
        component: () => import('../views/systemManagement/menuManagement/index.vue'),
        meta: {
          title: '菜单中心'
        }
      },
      {
        path: '/systemManagement/user',
        name: 'userList',
        component: RouterView,
        redirect: '/systemManagement/userList',
        meta: {
          title: '账号中心',
          isMenu: true
        },
        children: [{
            path: '/systemManagement/userList',
            // name: 'userList',
            component: () => import('../views/systemManagement/user/index.vue')
          },
          {
            path: '/systemManagement/UserInforMation',
            name: 'UserInforMation',
            component: () =>
              import('../views/systemManagement/user/components/userInforMation.vue'),
            meta: {
              title: '用户信息',
              isMenu: false
            }
          }
        ]
      },
      {
        path: '/systemManagement/newsList',
        name: 'newsList',
        component: () => import('../views/systemManagement/news/index.vue'),
        meta: {
          title: '消息提醒',
          isMenu: true
        }
      },
      {
        path: '/systemManagement/jurisdiction',
        name: 'jurisdiction',
        component: () => import('../views/systemManagement/jurisdiction/index.vue'),
        meta: {
          title: '角色中心',
          isMenu: true
        }
      },
      {
        path: '/systemManagement/journal',
        name: 'journal',
        component: () => import('../views/systemManagement/journal/index.vue'),
        meta: {
          title: '项目日志',
          isMenu: true
        }
      }
    ]
  }
]

export default menuList
